import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { CloudArrowUpIcon, TrashIcon, DocumentCheckIcon } from "../../../images/icons";
// import { trackEvent } from "services/analytics";

export default function (props) {
  const [files, setFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: ["image/*"],
    onDrop: (acceptedFiles, rejectedFiles) => {
      let totalFiles;
      if (files.length > 0) {
        totalFiles = [...files, ...acceptedFiles.slice(0, props.maxFiles - files.length)];
      } else {
        totalFiles = acceptedFiles.slice(0, props.maxFiles);
      }
      props.onDrop(totalFiles);

      if (rejectedFiles.length > 0) {
        alert(`${rejectedFiles.length} file gagal diupload (melebihi batas ukuran size 5MB)`);
      }
      setFiles(
        totalFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
    maxSize: props.maxSize,
  });

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  useEffect(() => {
    setFiles(props.images);
  }, []);

  const onDeleteImage = (idx) => {
    const newFiles = [...files];
    newFiles.splice(idx, 1);
    props.onDrop(newFiles);
    setFiles(
      newFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  };

  return (
    <div>
      {files.length < 3 ? (
        <section
          className="container text-sm text-gray-900"
          // onClick={() => trackEvent("Ticket UploadFile")}
        >
          <div {...getRootProps({ className: "dropzone" })}>
            <div className=" mt-1 text-center px-4 py-3 border border-gray-700 rounded-lg">
              <div className="flex justify-center mb-2">
                <div className="p-2 border rounded-lg w-auto">
                  <CloudArrowUpIcon className="w-5 h-5 flex-shrink-0 text-gray-700" aria-hidden />
                </div>
              </div>
              <input {...getInputProps()} />

              <div className="cursor-pointer text-primary hover:underline">
                Klik Untuk Upload Dokumen Pendukung
              </div>

              <div className="text-sm text-gray-700">PNG, JPG (Max. 5MB)</div>
              <div className="text-xxs text-gray-700">(Maksimal upload 3 file)</div>
            </div>
          </div>
        </section>
      ) : (
        <section className="container text-sm text-gray-900">
          <div className=" mt-1 text-center px-6 py-3 border border-gray-700 rounded-lg bg-gray-300">
            <div className="flex justify-center mb-2">
              <div className="p-2 border rounded-lg w-auto bg-white border-gray-500">
                <CloudArrowUpIcon className="w-5 h-5 flex-shrink-0 text-gray-700" aria-hidden />
              </div>
            </div>

            <div className="text-gray-700">Klik Untuk Upload Dokumen Pendukung</div>

            <div className="text-sm text-gray-700">PNG, JPG (Max. 5MB)</div>
            <div className="text-xxs text-gray-700">(Maksimal upload 3 file)</div>
          </div>
        </section>
      )}
      <div className="mt-3 space-y-3">
        {props.images?.length > 0
          ? props.images.map((i, idx) => {
              return (
                <section className="container text-sm text-gray-900" key={idx}>
                  <div className="flex justify-between px-3 py-3 border border-gray-500 rounded-lg space-x-2">
                    <div className="flex space-x-3 items-center">
                      <div>
                        <div className="border p-1.5 rounded-lg bg-white border-gray-500">
                          <DocumentCheckIcon
                            className="w-4 h-5 flex-shrink-0 text-primary"
                            aria-hidden
                          />
                        </div>
                      </div>
                      <div>
                        <div
                          role="button"
                          onClick={() => props.onClickImage(idx)}
                          aria-hidden
                          className="text-primary hover:underline cursor-pointer"
                        >
                          {i.path}
                        </div>
                        <div className="text-gray-700 text-xs mt-1">
                          {Math.ceil((i.size / 1000000) * 100) / 100}MB
                        </div>
                      </div>
                    </div>

                    <div
                      role="button"
                      aria-hidden
                      onClick={() => {
                        // trackEvent("Ticket DeleteFile");
                        onDeleteImage(idx);
                      }}
                      className="flex text-danger-700  space-x-1 items-center cursor-pointer"
                    >
                      <TrashIcon className="w-5 h-auto flex-shrink-0" aria-hidden />
                      <div className="text-xs font-bold">Hapus Foto</div>
                    </div>
                  </div>
                </section>
              );
            })
          : null}
      </div>
    </div>
  );
}
